import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-ricorso-lavoro-view',
  templateUrl: './form-ricorso-lavoro-view.component.html',
  styleUrls: ['./form-ricorso-lavoro-view.component.css']
})
export class FormRicorsoLavoroViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
